import { Inject, Injectable } from '@angular/core';
import { TENANT_NAME } from '@rd/core/tokens/rd-lib.token';

@Injectable({
  providedIn: 'root',
})
export class StaticPagesHelper {
  constructor(@Inject(TENANT_NAME) private tenantName: string) {}

  fullPageName(partialPageName: string): string {
    return `${this.tenantName}--${partialPageName}`;
  }
}
